import { DEFAULTS } from './defaults';

export const CommonHeaders = [
  {
    text: '',
    sortable: false,
    class: 'table-item-info',
    value: 'info_section'
  }
];

export const HEADERS = {
  ALL: [
    {
      text: 'Status',
      align: 'center',
      sortable: false,
      value: 'status',
      width: 20,
      'max-width': 20
    },
    {
      text: 'Original category name',
      align: 'center',
      value: 'orig_cat1',
      width: 200
    },
    {
      text: 'Original code',
      align: 'center',
      value: 'orig_code',
      width: 100
    },
    {
      text: 'Original name',
      align: 'center',
      value: 'orig_name',
      width: 100
    },
    {
      text: 'Rhapsody name',
      align: 'center',
      value: 'rhapsody_name',
      width: 100
    },
    {
      text: 'Entry variation name',
      align: 'center',
      value: 'entry_variation_name',
      width: 100
    },
    {
      text: 'Category',
      align: 'center',
      value: 'category',
      width: 100
    },
    {
      text: 'Rhapsody code',
      align: 'center',
      value: 'rhapsody_code',
      width: 100
    },
    {
      text: 'Variation',
      align: 'center',
      value: 'variation'
    },
    {
      text: 'Mapped type',
      align: 'center',
      value: 'mapped_core_type',
      width: 130
    },
    {
      width: 100,
      text: 'Dispensing fee',
      align: 'center',
      value: 'dispensing_fee'
    },
    {
      width: 100,
      text: 'Price',
      align: 'center',
      value: 'priceInfo.price'
    },
    {
      width: 50,
      text: 'Minimum price',
      align: 'center',
      value: 'priceInfo.minimum_price',
      sortable: true,
      type: 'pricePart'
    },
    {
      width: 150,
      text: 'Revenue percent',
      align: 'center',
      value: 'revenue_percent',
      sortable: true
    },
    {
      text: 'Classification priority',
      align: 'center',
      value: 'bucket',
      sortable: true
    },
    {
      width: 80,
      text: 'GL Code',
      align: 'center',
      value: 'custom_gl_code',
      sortable: true
    },
    {
      width: 80,
      text: 'Last sold',
      align: 'center',
      value: 'priceInfo.lastsold',
      sortable: true,
      type: 'pricePart'
    },
    {
      width: 50,
      text: 'Total sold',
      align: 'center',
      value: 'priceInfo.total_sold',
      sortable: true,
      type: 'pricePart'
    },
    {
      width: 50,
      text: 'Last year',
      align: 'center',
      value: 'priceInfo.total_sold_12',
      sortable: true,
      type: 'pricePart'
    },
    {
      width: 50,
      text: '2 years ago',
      align: 'center',
      value: 'priceInfo.total_sold_24',
      sortable: true,
      type: 'pricePart'
    },
    {
      width: 50,
      text: '3 years ago',
      align: 'center',
      value: 'priceInfo.total_sold_36',
      sortable: false,
      type: 'pricePart'
    },
    {
      text: 'UPC',
      align: 'center',
      value: 'upc',
      sortable: true
    },
    {
      text: 'NDC',
      align: 'center',
      value: 'ndc',
      sortable: true
    },
    {
      text: 'Barcode',
      align: 'center',
      value: 'barcode',
      sortable: true
    },
    {
      text: 'Reviewed',
      align: 'center',
      value: 'reviewed',
      sortable: true
    },
    {
      text: 'Customer verified',
      align: 'center',
      value: 'migrationPoll.checked',
      sortable: false
    },
    {
      text: 'Analysis status',
      align: 'center',
      value: 'analyze_status',
      sortable: false,
      width: 50
    },
    {
      text: 'Import status',
      align: 'center',
      value: 'import_status',
      sortable: false,
      width: 50
    },
    {
      text: 'Last comment',
      align: 'center',
      value: 'lastComment',
      width: 200
    },
    {
      text: 'Customer notes',
      align: 'center',
      value: 'migrationPoll.notes',
      sortable: false,
      width: 100
    },
    {
      text: 'Match Score',
      align: 'center',
      value: 'match_weight',
      width: 50
    },
    {
      text: 'External code',
      align: 'center',
      value: 'orig_external_code',
      width: 50
    },
    {
      text: 'Details',
      align: 'center',
      value: 'actions',
      width: 50
    }
    // {
    //     text: "History",
    //     align: "center",
    //     value: "data-table-expand",
    //     width: 50
    // }
  ],
  PROCEDURES: [
    {
      text: 'Status',
      align: 'center',
      sortable: false,
      value: 'status'
    },
    {
      text: 'Original category name',
      align: 'center',
      value: 'orig_cat1'
    },
    {
      text: 'Original code',
      align: 'center',
      value: 'orig_code'
    },
    {
      text: 'Original name',
      align: 'center',
      value: 'orig_name'
    },
    {
      text: 'Rhapsody name',
      align: 'center',
      value: 'rhapsody_name'
    },
    {
      text: 'Entry variation name',
      align: 'center',
      value: 'entry_variation_name',
      width: 100
    },
    {
      text: 'Rhapsody code',
      align: 'center',
      value: 'rhapsody_code',
      width: 100
    },
    {
      text: 'Variation',
      align: 'center',
      value: 'variation'
    },
    {
      width: 100,
      text: 'Dispensing fee',
      align: 'center',
      value: 'dispensing_fee'
    },
    {
      width: 100,
      text: 'Price',
      align: 'center',
      value: 'priceInfo.price'
    },
    {
      width: 50,
      text: 'Minimum price',
      align: 'center',
      value: 'priceInfo.minimum_price',
      sortable: true,
      type: 'pricePart'
    },
    {
      width: 150,
      text: 'Revenue percent',
      align: 'center',
      value: 'revenue_percent',
      sortable: true
    },
    {
      text: 'Classification priority',
      align: 'center',
      value: 'bucket',
      sortable: true
    },
    {
      width: 80,
      text: 'GL Code',
      align: 'center',
      value: 'custom_gl_code',
      sortable: true
    },
    {
      width: 80,
      text: 'Last sold',
      align: 'center',
      value: 'priceInfo.lastsold',
      sortable: true,
      type: 'pricePart'
    },
    {
      width: 50,
      text: 'Total sold',
      align: 'center',
      value: 'priceInfo.total_sold',
      sortable: true,
      type: 'pricePart'
    },
    {
      width: 50,
      text: 'Last year',
      align: 'center',
      value: 'priceInfo.total_sold_12',
      sortable: true,
      type: 'pricePart'
    },
    {
      width: 50,
      text: '2 years ago',
      align: 'center',
      value: 'priceInfo.total_sold_24',
      sortable: true,
      type: 'pricePart'
    },
    {
      width: 50,
      text: '3 years ago',
      align: 'center',
      value: 'priceInfo.total_sold_36',
      sortable: false,
      type: 'pricePart'
    },
    {
      text: 'UPC',
      align: 'center',
      value: 'upc',
      sortable: true
    },
    {
      text: 'NDC',
      align: 'center',
      value: 'ndc',
      sortable: true
    },
    {
      text: 'Barcode',
      align: 'center',
      value: 'barcode',
      sortable: true
    },
    {
      text: 'Reviewed',
      align: 'center',
      value: 'reviewed',
      sortable: true
    },
    {
      text: 'Customer verified',
      align: 'center',
      value: 'migrationPoll.checked',
      sortable: false
    },
    {
      text: 'Analysis status',
      align: 'center',
      value: 'analyze_status',
      sortable: false
    },
    {
      text: 'Import status',
      align: 'center',
      value: 'import_status',
      sortable: false
    },
    {
      text: 'Last comment',
      align: 'center',
      value: 'lastComment',
      width: 200
    },
    {
      text: 'Customer notes',
      align: 'center',
      value: 'migrationPoll.notes',
      sortable: false,
      width: 100
    },
    {
      text: 'Match Score',
      align: 'center',
      value: 'match_weight',
      width: 50
    },
    {
      text: 'External code',
      align: 'center',
      value: 'orig_external_code',
      width: 50
    },
    {
      text: 'Details',
      align: 'center',
      value: 'actions'
    }
    // {
    //     text: "History",
    //     align: "center",
    //     value: "data-table-expand"
    // }
  ],
  LABS: [
    {
      text: 'Status',
      align: 'center',
      sortable: false,
      value: 'status'
    },
    {
      text: 'Original category name',
      align: 'center',
      value: 'orig_cat1'
    },
    {
      text: 'Original code',
      align: 'center',
      value: 'orig_code'
    },
    {
      text: 'Original name',
      align: 'center',
      value: 'orig_name'
    },
    {
      text: 'Rhapsody name',
      align: 'center',
      value: 'rhapsody_name'
    },
    {
      text: 'Entry variation name',
      align: 'center',
      value: 'entry_variation_name',
      width: 100
    },
    {
      text: 'Rhapsody code',
      align: 'center',
      value: 'rhapsody_code',
      width: 100
    },
    {
      text: 'Variation',
      align: 'center',
      value: 'variation'
    },
    {
      text: 'Vendor ',
      align: 'center',
      value: 'vendor'
    },
    {
      text: 'Vendor code',
      align: 'center',
      value: 'vendor_code'
    },
    {
      width: 100,
      text: 'Dispensing fee',
      align: 'center',
      value: 'dispensing_fee'
    },
    {
      width: 100,
      text: 'Price',
      align: 'center',
      value: 'priceInfo.price'
    },
    {
      width: 50,
      text: 'Minimum price',
      align: 'center',
      value: 'priceInfo.minimum_price',
      sortable: true,
      type: 'pricePart'
    },
    {
      width: 150,
      text: 'Revenue percent',
      align: 'center',
      value: 'revenue_percent',
      sortable: true
    },
    {
      text: 'Classification priority',
      align: 'center',
      value: 'bucket',
      sortable: true
    },
    {
      width: 80,
      text: 'GL Code',
      align: 'center',
      value: 'custom_gl_code',
      sortable: true
    },
    {
      width: 80,
      text: 'Last sold',
      align: 'center',
      value: 'priceInfo.lastsold',
      sortable: true,
      type: 'pricePart'
    },
    {
      width: 50,
      text: 'Total sold',
      align: 'center',
      value: 'priceInfo.total_sold',
      sortable: true,
      type: 'pricePart'
    },
    {
      width: 50,
      text: 'Last year',
      align: 'center',
      value: 'priceInfo.total_sold_12',
      sortable: true,
      type: 'pricePart'
    },
    {
      width: 50,
      text: '2 years ago',
      align: 'center',
      value: 'priceInfo.total_sold_24',
      sortable: true,
      type: 'pricePart'
    },
    {
      width: 50,
      text: '3 years ago',
      align: 'center',
      value: 'priceInfo.total_sold_36',
      sortable: false,
      type: 'pricePart'
    },
    {
      text: 'UPC',
      align: 'center',
      value: 'upc',
      sortable: true
    },
    {
      text: 'NDC',
      align: 'center',
      value: 'ndc',
      sortable: true
    },
    {
      text: 'Barcode',
      align: 'center',
      value: 'barcode',
      sortable: true
    },
    {
      text: 'Reviewed',
      align: 'center',
      value: 'reviewed',
      sortable: true
    },
    {
      text: 'Customer verified',
      align: 'center',
      value: 'migrationPoll.checked',
      sortable: false
    },
    {
      text: 'Analysis status',
      align: 'center',
      value: 'analyze_status',
      sortable: false
    },
    {
      text: 'Import status',
      align: 'center',
      value: 'import_status',
      sortable: false
    },
    {
      text: 'Last comment',
      align: 'center',
      value: 'lastComment',
      width: 200
    },
    {
      text: 'Customer notes',
      align: 'center',
      value: 'migrationPoll.notes',
      sortable: false,
      width: 100
    },
    {
      text: 'Match Score',
      align: 'center',
      value: 'match_weight',
      width: 50
    },
    {
      text: 'External code',
      align: 'center',
      value: 'orig_external_code',
      width: 50
    },
    {
      text: 'Details',
      align: 'center',
      value: 'actions'
    }
    // {
    //     text: "History",
    //     align: "center",
    //     value: "data-table-expand"
    // }
  ],
  DRUGS: [
    {
      text: 'Status',
      align: 'center',
      sortable: false,
      value: 'status'
    },
    {
      text: 'Original category name',
      align: 'center',
      value: 'orig_cat1'
    },
    {
      text: 'Original code',
      align: 'center',
      value: 'orig_code'
    },
    {
      text: 'Original name',
      align: 'center',
      value: 'orig_name'
    },
    {
      text: 'Rhapsody name',
      align: 'center',
      value: 'rhapsody_name'
    },
    {
      text: 'Entry variation name',
      align: 'center',
      value: 'entry_variation_name',
      width: 100
    },
    {
      text: 'Rhapsody code',
      align: 'center',
      value: 'rhapsody_code',
      width: 100
    },
    {
      text: 'Variation ',
      align: 'center',
      value: 'variation'
    },
    {
      width: 100,
      text: 'Dispensing fee',
      align: 'center',
      value: 'dispensing_fee'
    },
    {
      width: 100,
      text: 'Price',
      align: 'center',
      value: 'priceInfo.price'
    },
    {
      width: 50,
      text: 'Minimum price',
      align: 'center',
      value: 'priceInfo.minimum_price',
      sortable: true,
      type: 'pricePart'
    },
    {
      width: 150,
      text: 'Revenue percent',
      align: 'center',
      value: 'revenue_percent',
      sortable: true
    },
    {
      text: 'Classification priority',
      align: 'center',
      value: 'bucket',
      sortable: true
    },
    {
      width: 80,
      text: 'GL Code',
      align: 'center',
      value: 'custom_gl_code',
      sortable: true
    },
    {
      width: 80,
      text: 'Last sold',
      align: 'center',
      value: 'priceInfo.lastsold',
      sortable: true,
      type: 'pricePart'
    },
    {
      width: 50,
      text: 'Total sold',
      align: 'center',
      value: 'priceInfo.total_sold',
      sortable: true,
      type: 'pricePart'
    },
    {
      width: 50,
      text: 'Last year',
      align: 'center',
      value: 'priceInfo.total_sold_12',
      sortable: true,
      type: 'pricePart'
    },
    {
      width: 50,
      text: '2 years ago',
      align: 'center',
      value: 'priceInfo.total_sold_24',
      sortable: true,
      type: 'pricePart'
    },
    {
      width: 50,
      text: '3 years ago',
      align: 'center',
      value: 'priceInfo.total_sold_36',
      sortable: false,
      type: 'pricePart'
    },
    {
      text: 'UPC',
      align: 'center',
      value: 'upc',
      sortable: true
    },
    {
      text: 'NDC',
      align: 'center',
      value: 'ndc',
      sortable: true
    },
    {
      text: 'Barcode',
      align: 'center',
      value: 'barcode',
      sortable: true
    },
    {
      width: 50,
      text: 'Obsolete',
      align: 'center',
      value: 'propsStructure.obsolete',
      sortable: false
    },
    {
      width: 50,
      text: 'Compounded',
      align: 'center',
      value: 'propsStructure.compounded',
      sortable: false
    },
    {
      text: 'Reviewed',
      align: 'center',
      value: 'reviewed',
      sortable: true
    },
    {
      text: 'Customer verified',
      align: 'center',
      value: 'migrationPoll.checked',
      sortable: false
    },
    {
      text: 'Analysis status',
      align: 'center',
      value: 'analyze_status',
      sortable: false
    },
    {
      text: 'Import status',
      align: 'center',
      value: 'import_status',
      sortable: false
    },
    {
      text: 'Last comment',
      align: 'center',
      value: 'lastComment',
      width: 200
    },
    {
      text: 'Customer notes',
      align: 'center',
      value: 'migrationPoll.notes',
      sortable: false,
      width: 100
    },
    {
      text: 'Match Score',
      align: 'center',
      value: 'match_weight',
      width: 50
    },
    {
      text: 'External code',
      align: 'center',
      value: 'orig_external_code',
      width: 50
    },
    {
      text: 'Details',
      align: 'center',
      value: 'actions'
    }
    // {
    //     text: "History",
    //     align: "center",
    //     value: "data-table-expand"
    // }
  ],
  VACCINES: [
    {
      text: 'Status',
      align: 'center',
      sortable: false,
      value: 'status'
    },
    {
      text: 'Original category name',
      align: 'center',
      value: 'orig_cat1'
    },
    {
      text: 'Original code',
      align: 'center',
      value: 'orig_code'
    },
    {
      text: 'Original name',
      align: 'center',
      value: 'orig_name'
    },
    {
      text: 'Rhapsody name',
      align: 'center',
      value: 'rhapsody_name'
    },
    {
      text: 'Entry variation name',
      align: 'center',
      value: 'entry_variation_name',
      width: 100
    },
    {
      text: 'Rhapsody code',
      align: 'center',
      value: 'rhapsody_code',
      width: 100
    },
    {
      text: 'Variation ',
      align: 'center',
      value: 'variation'
    },
    {
      width: 100,
      text: 'Dispensing fee',
      align: 'center',
      value: 'dispensing_fee'
    },
    {
      width: 100,
      text: 'Price',
      align: 'center',
      value: 'priceInfo.price'
    },
    {
      width: 50,
      text: 'Minimum price',
      align: 'center',
      value: 'priceInfo.minimum_price',
      sortable: true,
      type: 'pricePart'
    },
    {
      width: 150,
      text: 'Revenue percent',
      align: 'center',
      value: 'revenue_percent',
      sortable: true
    },
    {
      text: 'Classification priority',
      align: 'center',
      value: 'bucket',
      sortable: true
    },
    {
      width: 80,
      text: 'GL Code',
      align: 'center',
      value: 'custom_gl_code',
      sortable: true
    },
    {
      width: 80,
      text: 'Last sold',
      align: 'center',
      value: 'priceInfo.lastsold',
      sortable: true,
      type: 'pricePart'
    },
    {
      width: 50,
      text: 'Total sold',
      align: 'center',
      value: 'priceInfo.total_sold',
      sortable: true,
      type: 'pricePart'
    },
    {
      width: 50,
      text: 'Last year',
      align: 'center',
      value: 'priceInfo.total_sold_12',
      sortable: true,
      type: 'pricePart'
    },
    {
      width: 50,
      text: '2 years ago',
      align: 'center',
      value: 'priceInfo.total_sold_24',
      sortable: true,
      type: 'pricePart'
    },
    {
      width: 50,
      text: '3 years ago',
      align: 'center',
      value: 'priceInfo.total_sold_36',
      sortable: false,
      type: 'pricePart'
    },
    {
      text: 'UPC',
      align: 'center',
      value: 'upc',
      sortable: true
    },
    {
      text: 'NDC',
      align: 'center',
      value: 'ndc',
      sortable: true
    },
    {
      text: 'Barcode',
      align: 'center',
      value: 'barcode',
      sortable: true
    },
    {
      width: 50,
      text: 'Obsolete',
      align: 'center',
      value: 'propsStructure.obsolete',
      sortable: false
    },
    {
      width: 50,
      text: 'Compounded',
      align: 'center',
      value: 'propsStructure.compounded',
      sortable: false
    },
    {
      text: 'Reviewed',
      align: 'center',
      value: 'reviewed',
      sortable: true
    },
    {
      text: 'Customer verified',
      align: 'center',
      value: 'migrationPoll.checked',
      sortable: false
    },
    {
      text: 'Analysis status',
      align: 'center',
      value: 'analyze_status',
      sortable: false
    },
    {
      text: 'Import status',
      align: 'center',
      value: 'import_status',
      sortable: false
    },
    {
      text: 'Last comment',
      align: 'center',
      value: 'lastComment',
      width: 200
    },
    {
      text: 'Customer notes',
      align: 'center',
      value: 'migrationPoll.notes',
      sortable: false,
      width: 100
    },
    {
      text: 'Match Score',
      align: 'center',
      value: 'match_weight',
      width: 50
    },
    {
      text: 'External code',
      align: 'center',
      value: 'orig_external_code',
      width: 50
    },
    {
      text: 'Details',
      align: 'center',
      value: 'actions'
    }
    // {
    //     text: "History",
    //     align: "center",
    //     value: "data-table-expand"
    // }
  ],
  FOOD: [
    {
      text: 'Status',
      align: 'center',
      sortable: false,
      value: 'status'
    },
    {
      text: 'Original category name',
      align: 'center',
      value: 'orig_cat1'
    },
    {
      text: 'Original code',
      align: 'center',
      value: 'orig_code'
    },
    {
      text: 'Original name',
      align: 'center',
      value: 'orig_name'
    },
    {
      text: 'Rhapsody name',
      align: 'center',
      value: 'rhapsody_name'
    },
    {
      text: 'Entry variation name',
      align: 'center',
      value: 'entry_variation_name',
      width: 100
    },
    {
      text: 'Rhapsody code',
      align: 'center',
      value: 'rhapsody_code',
      width: 100
    },
    {
      text: 'Variation',
      align: 'center',
      value: 'variation'
    },
    {
      text: 'Subcategory ',
      align: 'center',
      value: 'subcategory'
    },
    {
      width: 100,
      text: 'Dispensing fee',
      align: 'center',
      value: 'dispensing_fee'
    },
    {
      width: 100,
      text: 'Price',
      align: 'center',
      value: 'priceInfo.price'
    },
    {
      width: 50,
      text: 'Minimum price',
      align: 'center',
      value: 'priceInfo.minimum_price',
      sortable: true,
      type: 'pricePart'
    },
    {
      width: 150,
      text: 'Revenue percent',
      align: 'center',
      value: 'revenue_percent',
      sortable: true
    },
    {
      text: 'Classification priority',
      align: 'center',
      value: 'bucket',
      sortable: true
    },
    {
      width: 80,
      text: 'GL Code',
      align: 'center',
      value: 'custom_gl_code',
      sortable: true
    },
    {
      width: 80,
      text: 'Last sold',
      align: 'center',
      value: 'priceInfo.lastsold',
      sortable: true,
      type: 'pricePart'
    },
    {
      width: 50,
      text: 'Total sold',
      align: 'center',
      value: 'priceInfo.total_sold',
      sortable: true,
      type: 'pricePart'
    },
    {
      width: 50,
      text: 'Last year',
      align: 'center',
      value: 'priceInfo.total_sold_12',
      sortable: true,
      type: 'pricePart'
    },
    {
      width: 50,
      text: '2 years ago',
      align: 'center',
      value: 'priceInfo.total_sold_24',
      sortable: true,
      type: 'pricePart'
    },
    {
      width: 50,
      text: '3 years ago',
      align: 'center',
      value: 'priceInfo.total_sold_36',
      sortable: false,
      type: 'pricePart'
    },
    {
      text: 'UPC',
      align: 'center',
      value: 'upc',
      sortable: true
    },
    {
      text: 'NDC',
      align: 'center',
      value: 'ndc',
      sortable: true
    },
    {
      text: 'Barcode',
      align: 'center',
      value: 'barcode',
      sortable: true
    },
    {
      text: 'Reviewed',
      align: 'center',
      value: 'reviewed',
      sortable: true
    },
    {
      text: 'Customer verified',
      align: 'center',
      value: 'migrationPoll.checked',
      sortable: false
    },
    {
      text: 'Analysis status',
      align: 'center',
      value: 'analyze_status',
      sortable: false
    },
    {
      text: 'Import status',
      align: 'center',
      value: 'import_status',
      sortable: false
    },
    {
      text: 'Last comment',
      align: 'center',
      value: 'lastComment',
      width: 200
    },
    {
      text: 'Customer notes',
      align: 'center',
      value: 'migrationPoll.notes',
      sortable: false,
      width: 100
    },
    {
      text: 'Match Score',
      align: 'center',
      value: 'match_weight',
      width: 50
    },
    {
      text: 'External code',
      align: 'center',
      value: 'orig_external_code',
      width: 50
    },
    {
      text: 'Details',
      align: 'center',
      value: 'actions'
    }
    // {
    //     text: "History",
    //     align: "center",
    //     value: "data-table-expand"
    // }
  ],
  SUPPLIES: [
    {
      text: 'Status',
      align: 'center',
      sortable: false,
      value: 'status'
    },
    {
      text: 'Original category name',
      align: 'center',
      value: 'orig_cat1'
    },
    {
      text: 'Original code',
      align: 'center',
      value: 'orig_code'
    },
    {
      text: 'Original name',
      align: 'center',
      value: 'orig_name'
    },
    {
      text: 'Rhapsody name',
      align: 'center',
      value: 'rhapsody_name'
    },
    {
      text: 'Entry variation name',
      align: 'center',
      value: 'entry_variation_name',
      width: 100
    },
    {
      text: 'Rhapsody code',
      align: 'center',
      value: 'rhapsody_code',
      width: 100
    },
    {
      text: 'Variation',
      align: 'center',
      value: 'variation'
    },
    {
      text: 'Subcategory ',
      align: 'center',
      value: 'subcategory'
    },
    {
      width: 100,
      text: 'Dispensing fee',
      align: 'center',
      value: 'dispensing_fee'
    },
    {
      width: 100,
      text: 'Price',
      align: 'center',
      value: 'priceInfo.price'
    },
    {
      width: 50,
      text: 'Minimum price',
      align: 'center',
      value: 'priceInfo.minimum_price',
      sortable: true,
      type: 'pricePart'
    },
    {
      width: 150,
      text: 'Revenue percent',
      align: 'center',
      value: 'revenue_percent',
      sortable: true
    },
    {
      text: 'Classification priority',
      align: 'center',
      value: 'bucket',
      sortable: true
    },
    {
      width: 80,
      text: 'GL Code',
      align: 'center',
      value: 'custom_gl_code',
      sortable: true
    },
    {
      width: 80,
      text: 'Last sold',
      align: 'center',
      value: 'priceInfo.lastsold',
      sortable: true,
      type: 'pricePart'
    },
    {
      width: 50,
      text: 'Total sold',
      align: 'center',
      value: 'priceInfo.total_sold',
      sortable: true,
      type: 'pricePart'
    },
    {
      width: 50,
      text: 'Last year',
      align: 'center',
      value: 'priceInfo.total_sold_12',
      sortable: true,
      type: 'pricePart'
    },
    {
      width: 50,
      text: '2 years ago',
      align: 'center',
      value: 'priceInfo.total_sold_24',
      sortable: true,
      type: 'pricePart'
    },
    {
      width: 50,
      text: '3 years ago',
      align: 'center',
      value: 'priceInfo.total_sold_36',
      sortable: false,
      type: 'pricePart'
    },
    {
      text: 'UPC',
      align: 'center',
      value: 'upc',
      sortable: true
    },
    {
      text: 'NDC',
      align: 'center',
      value: 'ndc',
      sortable: true
    },
    {
      text: 'Barcode',
      align: 'center',
      value: 'barcode',
      sortable: true
    },
    {
      text: 'Reviewed',
      align: 'center',
      value: 'reviewed',
      sortable: true
    },
    {
      text: 'Customer verified',
      align: 'center',
      value: 'migrationPoll.checked',
      sortable: false
    },
    {
      text: 'Analysis status',
      align: 'center',
      value: 'analyze_status',
      sortable: false
    },
    {
      text: 'Import status',
      align: 'center',
      value: 'import_status',
      sortable: false
    },
    {
      text: 'Last comment',
      align: 'center',
      value: 'lastComment',
      width: 200
    },
    {
      text: 'Customer notes',
      align: 'center',
      value: 'migrationPoll.notes',
      sortable: false,
      width: 100
    },
    {
      text: 'Match Score',
      align: 'center',
      value: 'match_weight',
      width: 50
    },
    {
      text: 'External code',
      align: 'center',
      value: 'orig_external_code',
      width: 50
    },
    {
      text: 'Details',
      align: 'center',
      value: 'actions'
    }
    // {
    //     text: "History",
    //     align: "center",
    //     value: "data-table-expand"
    // }
  ],
  IGNORED: [
    {
      text: 'Status',
      align: 'center',
      sortable: false,
      value: 'status'
    },
    {
      text: 'Original category name',
      align: 'center',
      value: 'orig_cat1'
    },
    {
      text: 'Original code',
      align: 'center',
      value: 'orig_code'
    },
    {
      text: 'Original name',
      align: 'center',
      value: 'orig_name'
    },
    {
      text: 'Rhapsody code',
      align: 'center',
      value: 'rhapsody_code',
      width: 100
    },
    {
      text: 'Mapped type',
      align: 'center',
      value: 'mapped_core_type',
      width: 130
    },
    {
      text: 'Variation',
      align: 'center',
      value: 'variation'
    },
    {
      width: 100,
      text: 'Dispensing fee',
      align: 'center',
      value: 'dispensing_fee'
    },
    {
      width: 100,
      text: 'Price',
      align: 'center',
      value: 'priceInfo.price'
    },
    {
      width: 50,
      text: 'Minimum price',
      align: 'center',
      value: 'priceInfo.minimum_price',
      sortable: true,
      type: 'pricePart'
    },
    {
      width: 150,
      text: 'Revenue percent',
      align: 'center',
      value: 'revenue_percent',
      sortable: true
    },
    {
      text: 'Classification priority',
      align: 'center',
      value: 'bucket',
      sortable: true
    },
    {
      width: 80,
      text: 'GL Code',
      align: 'center',
      value: 'custom_gl_code',
      sortable: true
    },
    {
      width: 80,
      text: 'Last sold',
      align: 'center',
      value: 'priceInfo.lastsold',
      sortable: true,
      type: 'pricePart'
    },
    {
      width: 50,
      text: 'Total sold',
      align: 'center',
      value: 'priceInfo.total_sold',
      sortable: true,
      type: 'pricePart'
    },
    {
      width: 50,
      text: 'Last year',
      align: 'center',
      value: 'priceInfo.total_sold_12',
      sortable: true,
      type: 'pricePart'
    },
    {
      width: 50,
      text: '2 years ago',
      align: 'center',
      value: 'priceInfo.total_sold_24',
      sortable: true,
      type: 'pricePart'
    },
    {
      width: 50,
      text: '3 years ago',
      align: 'center',
      value: 'priceInfo.total_sold_36',
      sortable: false,
      type: 'pricePart'
    },
    {
      text: 'UPC',
      align: 'center',
      value: 'upc',
      sortable: true
    },
    {
      text: 'NDC',
      align: 'center',
      value: 'ndc',
      sortable: true
    },
    {
      text: 'Barcode',
      align: 'center',
      value: 'barcode',
      sortable: true
    },
    {
      text: 'Reviewed',
      align: 'center',
      value: 'reviewed',
      sortable: true
    },
    {
      text: 'Customer verified',
      align: 'center',
      value: 'migrationPoll.checked',
      sortable: false
    },
    {
      text: 'Analysis status',
      align: 'center',
      value: 'analyze_status',
      sortable: false
    },
    {
      text: 'Import status',
      align: 'center',
      value: 'import_status',
      sortable: false
    },
    {
      text: 'Last comment',
      align: 'center',
      value: 'lastComment',
      width: 200
    },
    {
      text: 'Customer notes',
      align: 'center',
      value: 'migrationPoll.notes',
      sortable: false,
      width: 100
    },
    {
      text: 'Match Score',
      align: 'center',
      value: 'match_weight',
      width: 50
    },
    {
      text: 'External code',
      align: 'center',
      value: 'orig_external_code',
      width: 50
    },
    {
      text: 'Details',
      align: 'center',
      value: 'actions'
    }
    // {
    //     text: "History",
    //     align: "center",
    //     value: "data-table-expand"
    // }
  ],
  UNMATCHED: [
    {
      text: 'Status',
      align: 'center',
      sortable: false,
      value: 'status'
    },
    {
      text: 'Original category name',
      align: 'center',
      value: 'orig_cat1'
    },
    {
      text: 'Original code',
      align: 'center',
      value: 'orig_code'
    },
    {
      text: 'Original name',
      align: 'center',
      value: 'orig_name'
    },
    {
      text: 'Rhapsody code',
      align: 'center',
      value: 'rhapsody_code',
      width: 100
    },
    {
      text: 'Variation',
      align: 'center',
      value: 'variation'
    },
    {
      width: 100,
      text: 'Dispensing fee',
      align: 'center',
      value: 'dispensing_fee'
    },
    {
      width: 100,
      text: 'Price',
      align: 'center',
      value: 'priceInfo.price'
    },
    {
      width: 50,
      text: 'Minimum price',
      align: 'center',
      value: 'priceInfo.minimum_price',
      sortable: true,
      type: 'pricePart'
    },
    {
      width: 150,
      text: 'Revenue percent',
      align: 'center',
      value: 'revenue_percent',
      sortable: true
    },
    {
      text: 'Classification priority',
      align: 'center',
      value: 'bucket',
      sortable: true
    },
    {
      width: 80,
      text: 'GL Code',
      align: 'center',
      value: 'custom_gl_code',
      sortable: true
    },
    {
      width: 80,
      text: 'Last sold',
      align: 'center',
      value: 'priceInfo.lastsold',
      sortable: true,
      type: 'pricePart'
    },
    {
      width: 50,
      text: 'Total sold',
      align: 'center',
      value: 'priceInfo.total_sold',
      sortable: true,
      type: 'pricePart'
    },
    {
      width: 50,
      text: 'Last year',
      align: 'center',
      value: 'priceInfo.total_sold_12',
      sortable: true,
      type: 'pricePart'
    },
    {
      width: 50,
      text: '2 years ago',
      align: 'center',
      value: 'priceInfo.total_sold_24',
      sortable: true,
      type: 'pricePart'
    },
    {
      width: 50,
      text: '3 years ago',
      align: 'center',
      value: 'priceInfo.total_sold_36',
      sortable: false,
      type: 'pricePart'
    },
    {
      text: 'UPC',
      align: 'center',
      value: 'upc',
      sortable: true
    },
    {
      text: 'NDC',
      align: 'center',
      value: 'ndc',
      sortable: true
    },
    {
      text: 'Barcode',
      align: 'center',
      value: 'barcode',
      sortable: true
    },
    {
      text: 'Reviewed',
      align: 'center',
      value: 'reviewed',
      sortable: true
    },
    {
      text: 'Customer verified',
      align: 'center',
      value: 'migrationPoll.checked',
      sortable: false
    },
    {
      text: 'Analysis status',
      align: 'center',
      value: 'analyze_status',
      sortable: false
    },
    {
      text: 'Import status',
      align: 'center',
      value: 'import_status',
      sortable: false
    },
    {
      text: 'Last comment',
      align: 'center',
      value: 'lastComment',
      width: 200
    },
    {
      text: 'Customer notes',
      align: 'center',
      value: 'migrationPoll.notes',
      sortable: false,
      width: 100
    },
    {
      text: 'Match Score',
      align: 'center',
      value: 'match_weight',
      width: 50
    },
    {
      text: 'External code',
      align: 'center',
      value: 'orig_external_code',
      width: 50
    },
    {
      text: 'Details',
      align: 'center',
      value: 'actions'
    }
    // {
    //     text: "History",
    //     align: "center",
    //     value: "data-table-expand"
    // }
  ],
  MULTI_MATCH: [
    {
      text: 'Multi match selection',
      align: 'center',
      value: 'multimatch_selection',
      width: '10',
      sortable: false
    },
    {
      text: 'Status',
      align: 'center',
      sortable: false,
      value: 'status'
    },
    {
      text: 'Original category name',
      align: 'center',
      value: 'orig_cat1'
    },
    // {
    //     text: "Original code",
    //     align: "center",
    //     value: "orig_code"
    // },
    // {
    //     text: "Original name",
    //     align: "center",
    //     value: "orig_name"
    // },
    {
      text: 'Rhapsody name',
      align: 'center',
      value: 'rhapsody_name'
    },
    {
      text: 'Entry variation name',
      align: 'center',
      value: 'entry_variation_name',
      width: 100
    },
    {
      text: 'Rhapsody code',
      align: 'center',
      value: 'rhapsody_code',
      width: 100
    },
    {
      text: 'Variation',
      align: 'center',
      value: 'variation'
    },
    {
      text: 'Category name',
      align: 'center',
      value: 'category'
    },
    {
      width: 100,
      text: 'Dispensing fee',
      align: 'center',
      value: 'dispensing_fee'
    },
    {
      width: 100,
      text: 'Price',
      align: 'center',
      value: 'priceInfo.price'
    },
    {
      width: 50,
      text: 'Minimum price',
      align: 'center',
      value: 'priceInfo.minimum_price',
      sortable: true,
      type: 'pricePart'
    },
    {
      width: 150,
      text: 'Revenue percent',
      align: 'center',
      value: 'revenue_percent',
      sortable: true
    },
    {
      text: 'Classification priority',
      align: 'center',
      value: 'bucket',
      sortable: true
    },
    {
      width: 80,
      text: 'GL Code',
      align: 'center',
      value: 'custom_gl_code',
      sortable: true
    },
    {
      width: 80,
      text: 'Last sold',
      align: 'center',
      value: 'priceInfo.lastsold',
      sortable: true,
      type: 'pricePart'
    },
    {
      width: 50,
      text: 'Total sold',
      align: 'center',
      value: 'priceInfo.total_sold',
      sortable: true,
      type: 'pricePart'
    },
    {
      width: 50,
      text: 'Last year',
      align: 'center',
      value: 'priceInfo.total_sold_12',
      sortable: true,
      type: 'pricePart'
    },
    {
      width: 50,
      text: '2 years ago',
      align: 'center',
      value: 'priceInfo.total_sold_24',
      sortable: true,
      type: 'pricePart'
    },
    {
      width: 50,
      text: '3 years ago',
      align: 'center',
      value: 'priceInfo.total_sold_36',
      sortable: false,
      type: 'pricePart'
    },
    {
      text: 'Reviewed',
      align: 'center',
      value: 'reviewed',
      sortable: true
    },
    {
      text: 'Customer verified',
      align: 'center',
      value: 'migrationPoll.checked',
      sortable: false
    },
    {
      text: 'Analysis status',
      align: 'center',
      value: 'analyze_status',
      sortable: false
    },
    {
      text: 'Import status',
      align: 'center',
      value: 'import_status',
      sortable: false
    },
    {
      text: 'Last comment',
      align: 'center',
      value: 'lastComment',
      width: 200
    },
    {
      text: 'Customer notes',
      align: 'center',
      value: 'migrationPoll.notes',
      sortable: false,
      width: 100
    },
    {
      text: 'Match Score',
      align: 'center',
      value: 'match_weight',
      width: 50
    },
    {
      text: 'External code',
      align: 'center',
      value: 'orig_external_code',
      width: 50
    },
    {
      text: 'Details',
      align: 'center',
      value: 'actions'
    }
    // {
    //     text: "History",
    //     align: "center",
    //     value: "data-table-expand"
    // }
  ],
  ASK_CUSTOMER: [
    {
      text: 'Status',
      align: 'center',
      sortable: false,
      value: 'status'
    },
    {
      text: 'Original category name',
      align: 'center',
      value: 'orig_cat1'
    },
    {
      text: 'Original code',
      align: 'center',
      value: 'orig_code'
    },
    {
      text: 'Original name',
      align: 'center',
      value: 'orig_name'
    },
    {
      text: 'Rhapsody name',
      align: 'center',
      value: 'rhapsody_name'
    },
    {
      text: 'Entry variation name',
      align: 'center',
      value: 'entry_variation_name',
      width: 100
    },
    {
      text: 'Category name',
      align: 'center',
      value: 'category'
    },
    {
      width: 100,
      text: 'Dispensing fee',
      align: 'center',
      value: 'dispensing_fee'
    },
    {
      width: 100,
      text: 'Price',
      align: 'center',
      value: 'priceInfo.price'
    },
    {
      width: 50,
      text: 'Minimum price',
      align: 'center',
      value: 'priceInfo.minimum_price',
      sortable: true,
      type: 'pricePart'
    },
    {
      width: 150,
      text: 'Revenue percent',
      align: 'center',
      value: 'revenue_percent',
      sortable: true
    },
    {
      text: 'Classification priority',
      align: 'center',
      value: 'bucket',
      sortable: true
    },
    {
      width: 80,
      text: 'GL Code',
      align: 'center',
      value: 'custom_gl_code',
      sortable: true
    },
    {
      width: 80,
      text: 'Last sold',
      align: 'center',
      value: 'priceInfo.lastsold',
      sortable: true,
      type: 'pricePart'
    },
    {
      width: 50,
      text: 'Total sold',
      align: 'center',
      value: 'priceInfo.total_sold',
      sortable: true,
      type: 'pricePart'
    },
    {
      width: 50,
      text: 'Last year',
      align: 'center',
      value: 'priceInfo.total_sold_12',
      sortable: true,
      type: 'pricePart'
    },
    {
      width: 50,
      text: '2 years ago',
      align: 'center',
      value: 'priceInfo.total_sold_24',
      sortable: true,
      type: 'pricePart'
    },
    {
      width: 50,
      text: '3 years ago',
      align: 'center',
      value: 'priceInfo.total_sold_36',
      sortable: false,
      type: 'pricePart'
    },
    {
      text: 'UPC',
      align: 'center',
      value: 'upc',
      sortable: true
    },
    {
      text: 'NDC',
      align: 'center',
      value: 'ndc',
      sortable: true
    },
    {
      text: 'Barcode',
      align: 'center',
      value: 'barcode',
      sortable: true
    },
    {
      text: 'Reviewed',
      align: 'center',
      value: 'reviewed',
      sortable: true
    },
    {
      text: 'Customer verified',
      align: 'center',
      value: 'migrationPoll.checked',
      sortable: false
    },
    {
      text: 'Analysis status',
      align: 'center',
      value: 'analyze_status',
      sortable: false
    },
    {
      text: 'Import status',
      align: 'center',
      value: 'import_status',
      sortable: false
    },
    {
      text: 'Last comment',
      align: 'center',
      value: 'lastComment',
      width: 200
    },
    {
      text: 'Customer notes',
      align: 'center',
      value: 'migrationPoll.notes',
      sortable: false,
      width: 100
    },
    {
      text: 'Match Score',
      align: 'center',
      value: 'match_weight',
      width: 50
    },
    {
      text: 'External code',
      align: 'center',
      value: 'orig_external_code',
      width: 50
    },
    {
      text: 'Details',
      align: 'center',
      value: 'actions'
    }
    // {
    //     text: "History",
    //     align: "center",
    //     value: "data-table-expand"
    // }
  ],
  ADDITIONAL_REVIEW: [
    {
      text: 'Status',
      align: 'center',
      sortable: false,
      value: 'status'
    },
    {
      text: 'Original category name',
      align: 'center',
      value: 'orig_cat1'
    },
    {
      text: 'Original code',
      align: 'center',
      value: 'orig_code'
    },
    {
      text: 'Original name',
      align: 'center',
      value: 'orig_name'
    },
    {
      text: 'Rhapsody name',
      align: 'center',
      value: 'rhapsody_name'
    },
    {
      text: 'Category name',
      align: 'center',
      value: 'category'
    },
    {
      width: 100,
      text: 'Dispensing fee',
      align: 'center',
      value: 'dispensing_fee'
    },
    {
      width: 100,
      text: 'Price',
      align: 'center',
      value: 'priceInfo.price'
    },
    {
      width: 50,
      text: 'Minimum price',
      align: 'center',
      value: 'priceInfo.minimum_price',
      sortable: true,
      type: 'pricePart'
    },
    {
      width: 150,
      text: 'Revenue percent',
      align: 'center',
      value: 'revenue_percent',
      sortable: true
    },
    {
      text: 'Classification priority',
      align: 'center',
      value: 'bucket',
      sortable: true
    },
    {
      width: 80,
      text: 'GL Code',
      align: 'center',
      value: 'custom_gl_code',
      sortable: true
    },
    {
      width: 80,
      text: 'Last sold',
      align: 'center',
      value: 'priceInfo.lastsold',
      sortable: true,
      type: 'pricePart'
    },
    {
      width: 50,
      text: 'Total sold',
      align: 'center',
      value: 'priceInfo.total_sold',
      sortable: true,
      type: 'pricePart'
    },
    {
      width: 50,
      text: 'Last year',
      align: 'center',
      value: 'priceInfo.total_sold_12',
      sortable: true,
      type: 'pricePart'
    },
    {
      width: 50,
      text: '2 years ago',
      align: 'center',
      value: 'priceInfo.total_sold_24',
      sortable: true,
      type: 'pricePart'
    },
    {
      width: 50,
      text: '3 years ago',
      align: 'center',
      value: 'priceInfo.total_sold_36',
      sortable: false,
      type: 'pricePart'
    },
    {
      text: 'UPC',
      align: 'center',
      value: 'upc',
      sortable: true
    },
    {
      text: 'NDC',
      align: 'center',
      value: 'ndc',
      sortable: true
    },
    {
      text: 'Barcode',
      align: 'center',
      value: 'barcode',
      sortable: true
    },
    {
      text: 'Reviewed',
      align: 'center',
      value: 'reviewed',
      sortable: true
    },
    {
      text: 'Customer verified',
      align: 'center',
      value: 'migrationPoll.checked',
      sortable: false
    },
    {
      text: 'Analysis status',
      align: 'center',
      value: 'analyze_status',
      sortable: false
    },
    {
      text: 'Import status',
      align: 'center',
      value: 'import_status',
      sortable: false
    },
    {
      text: 'Last comment',
      align: 'center',
      value: 'lastComment',
      width: 200
    },
    {
      text: 'Customer notes',
      align: 'center',
      value: 'migrationPoll.notes',
      sortable: false,
      width: 100
    },
    {
      text: 'Match Score',
      align: 'center',
      value: 'match_weight',
      width: 50
    },
    {
      text: 'External code',
      align: 'center',
      value: 'orig_external_code',
      width: 50
    },
    {
      text: 'Details',
      align: 'center',
      value: 'actions'
    }
    // {
    //     text: "History",
    //     align: "center",
    //     value: "data-table-expand"
    // }
  ],
  ADDITIONAL_ANALYSIS: [
    {
      text: 'Status',
      align: 'center',
      sortable: false,
      value: 'status'
    },
    {
      text: 'Original category name',
      align: 'center',
      value: 'orig_cat1'
    },
    {
      text: 'Original code',
      align: 'center',
      value: 'orig_code'
    },
    {
      text: 'Original name',
      align: 'center',
      value: 'orig_name'
    },
    {
      text: 'Rhapsody name',
      align: 'center',
      value: 'rhapsody_name'
    },
    {
      text: 'Category name',
      align: 'center',
      value: 'category'
    },
    {
      width: 100,
      text: 'Dispensing fee',
      align: 'center',
      value: 'dispensing_fee'
    },
    {
      width: 100,
      text: 'Price',
      align: 'center',
      value: 'priceInfo.price'
    },
    {
      width: 50,
      text: 'Minimum price',
      align: 'center',
      value: 'priceInfo.minimum_price',
      sortable: true,
      type: 'pricePart'
    },
    {
      width: 150,
      text: 'Revenue percent',
      align: 'center',
      value: 'revenue_percent',
      sortable: true
    },
    {
      text: 'Classification priority',
      align: 'center',
      value: 'bucket',
      sortable: true
    },
    {
      width: 80,
      text: 'GL Code',
      align: 'center',
      value: 'custom_gl_code',
      sortable: true
    },
    {
      width: 80,
      text: 'Last sold',
      align: 'center',
      value: 'priceInfo.lastsold',
      sortable: true,
      type: 'pricePart'
    },
    {
      width: 50,
      text: 'Total sold',
      align: 'center',
      value: 'priceInfo.total_sold',
      sortable: true,
      type: 'pricePart'
    },
    {
      width: 50,
      text: 'Last year',
      align: 'center',
      value: 'priceInfo.total_sold_12',
      sortable: true,
      type: 'pricePart'
    },
    {
      width: 50,
      text: '2 years ago',
      align: 'center',
      value: 'priceInfo.total_sold_24',
      sortable: true,
      type: 'pricePart'
    },
    {
      width: 50,
      text: '3 years ago',
      align: 'center',
      value: 'priceInfo.total_sold_36',
      sortable: false,
      type: 'pricePart'
    },
    {
      text: 'UPC',
      align: 'center',
      value: 'upc',
      sortable: true
    },
    {
      text: 'NDC',
      align: 'center',
      value: 'ndc',
      sortable: true
    },
    {
      text: 'Barcode',
      align: 'center',
      value: 'barcode',
      sortable: true
    },
    {
      text: 'Reviewed',
      align: 'center',
      value: 'reviewed',
      sortable: true
    },
    {
      text: 'Customer verified',
      align: 'center',
      value: 'migrationPoll.checked',
      sortable: false
    },
    {
      text: 'Analysis status',
      align: 'center',
      value: 'analyze_status',
      sortable: false
    },
    {
      text: 'Import status',
      align: 'center',
      value: 'import_status',
      sortable: false
    },
    {
      text: 'Last comment',
      align: 'center',
      value: 'lastComment',
      width: 200
    },
    {
      text: 'Customer notes',
      align: 'center',
      value: 'migrationPoll.notes',
      sortable: false,
      width: 100
    },
    {
      text: 'Match Score',
      align: 'center',
      value: 'match_weight',
      width: 50
    },
    {
      text: 'External code',
      align: 'center',
      value: 'orig_external_code',
      width: 50
    },
    {
      text: 'Details',
      align: 'center',
      value: 'actions'
    }
    // {
    //     text: "History",
    //     align: "center",
    //     value: "data-table-expand"
    // }
  ],
  CONFLICTS: [
    {
      text: 'Status',
      align: 'center',
      sortable: false,
      value: 'status'
    },
    {
      text: 'Original category name',
      align: 'center',
      value: 'orig_cat1'
    },
    {
      text: 'Original code',
      align: 'center',
      value: 'orig_code'
    },
    {
      text: 'Original name',
      align: 'center',
      value: 'orig_name'
    },
    {
      text: 'Rhapsody name',
      align: 'center',
      value: 'rhapsody_name'
    },
    {
      text: 'Category name',
      align: 'center',
      value: 'category'
    },
    {
      width: 100,
      text: 'Dispensing fee',
      align: 'center',
      value: 'dispensing_fee'
    },
    {
      width: 100,
      text: 'Price',
      align: 'center',
      value: 'priceInfo.price'
    },
    {
      width: 50,
      text: 'Minimum price',
      align: 'center',
      value: 'priceInfo.minimum_price',
      sortable: true,
      type: 'pricePart'
    },
    {
      width: 150,
      text: 'Revenue percent',
      align: 'center',
      value: 'revenue_percent',
      sortable: true
    },
    {
      text: 'Classification priority',
      align: 'center',
      value: 'bucket',
      sortable: true
    },
    {
      width: 80,
      text: 'GL Code',
      align: 'center',
      value: 'custom_gl_code',
      sortable: true
    },
    {
      width: 80,
      text: 'Last sold',
      align: 'center',
      value: 'priceInfo.lastsold',
      sortable: true,
      type: 'pricePart'
    },
    {
      width: 50,
      text: 'Total sold',
      align: 'center',
      value: 'priceInfo.total_sold',
      sortable: true,
      type: 'pricePart'
    },
    {
      width: 50,
      text: 'Last year',
      align: 'center',
      value: 'priceInfo.total_sold_12',
      sortable: true,
      type: 'pricePart'
    },
    {
      width: 50,
      text: '2 years ago',
      align: 'center',
      value: 'priceInfo.total_sold_24',
      sortable: true,
      type: 'pricePart'
    },
    {
      width: 50,
      text: '3 years ago',
      align: 'center',
      value: 'priceInfo.total_sold_36',
      sortable: false,
      type: 'pricePart'
    },
    {
      text: 'UPC',
      align: 'center',
      value: 'upc',
      sortable: true
    },
    {
      text: 'NDC',
      align: 'center',
      value: 'ndc',
      sortable: true
    },
    {
      text: 'Barcode',
      align: 'center',
      value: 'barcode',
      sortable: true
    },
    {
      text: 'Reviewed',
      align: 'center',
      value: 'reviewed',
      sortable: true
    },
    {
      text: 'Customer verified',
      align: 'center',
      value: 'migrationPoll.checked',
      sortable: false
    },
    {
      text: 'Analysis status',
      align: 'center',
      value: 'analyze_status',
      sortable: false
    },
    {
      text: 'Import status',
      align: 'center',
      value: 'import_status',
      sortable: false
    },
    {
      text: 'Last comment',
      align: 'center',
      value: 'lastComment',
      width: 200
    },
    {
      text: 'Customer notes',
      align: 'center',
      value: 'migrationPoll.notes',
      sortable: false,
      width: 100
    },
    {
      text: 'Match Score',
      align: 'center',
      value: 'match_weight',
      width: 50
    },
    {
      text: 'External code',
      align: 'center',
      value: 'orig_external_code',
      width: 50
    },
    {
      text: 'Details',
      align: 'center',
      value: 'actions'
    }
    // {
    //     text: "History",
    //     align: "center",
    //     value: "data-table-expand"
    // }
  ],
  NEEDS_CHANGE: [
    {
      text: 'Status',
      align: 'center',
      sortable: false,
      value: 'status'
    },
    {
      text: 'Original category name',
      align: 'center',
      value: 'orig_cat1'
    },
    {
      text: 'Original code',
      align: 'center',
      value: 'orig_code'
    },
    {
      text: 'Original name',
      align: 'center',
      value: 'orig_name'
    },
    {
      text: 'Rhapsody name',
      align: 'center',
      value: 'rhapsody_name'
    },
    {
      text: 'Category name',
      align: 'center',
      value: 'category'
    },
    {
      width: 100,
      text: 'Dispensing fee',
      align: 'center',
      value: 'dispensing_fee'
    },
    {
      width: 100,
      text: 'Price',
      align: 'center',
      value: 'priceInfo.price'
    },
    {
      width: 50,
      text: 'Minimum price',
      align: 'center',
      value: 'priceInfo.minimum_price',
      sortable: true,
      type: 'pricePart'
    },
    {
      width: 150,
      text: 'Revenue percent',
      align: 'center',
      value: 'revenue_percent',
      sortable: true
    },
    {
      text: 'Classification priority',
      align: 'center',
      value: 'bucket',
      sortable: true
    },
    {
      width: 80,
      text: 'GL Code',
      align: 'center',
      value: 'custom_gl_code',
      sortable: true
    },
    {
      width: 80,
      text: 'Last sold',
      align: 'center',
      value: 'priceInfo.lastsold',
      sortable: true,
      type: 'pricePart'
    },
    {
      width: 50,
      text: 'Total sold',
      align: 'center',
      value: 'priceInfo.total_sold',
      sortable: true,
      type: 'pricePart'
    },
    {
      width: 50,
      text: 'Last year',
      align: 'center',
      value: 'priceInfo.total_sold_12',
      sortable: true,
      type: 'pricePart'
    },
    {
      width: 50,
      text: '2 years ago',
      align: 'center',
      value: 'priceInfo.total_sold_24',
      sortable: true,
      type: 'pricePart'
    },
    {
      width: 50,
      text: '3 years ago',
      align: 'center',
      value: 'priceInfo.total_sold_36',
      sortable: false,
      type: 'pricePart'
    },
    {
      text: 'UPC',
      align: 'center',
      value: 'upc',
      sortable: true
    },
    {
      text: 'NDC',
      align: 'center',
      value: 'ndc',
      sortable: true
    },
    {
      text: 'Barcode',
      align: 'center',
      value: 'barcode',
      sortable: true
    },
    {
      text: 'Reviewed',
      align: 'center',
      value: 'reviewed',
      sortable: true
    },
    {
      text: 'Customer verified',
      align: 'center',
      value: 'migrationPoll.checked',
      sortable: false
    },
    {
      text: 'Analysis status',
      align: 'center',
      value: 'analyze_status',
      sortable: false
    },
    {
      text: 'Import status',
      align: 'center',
      value: 'import_status',
      sortable: false
    },
    {
      text: 'Last comment',
      align: 'center',
      value: 'lastComment',
      width: 200
    },
    {
      text: 'Customer notes',
      align: 'center',
      value: 'migrationPoll.notes',
      sortable: false,
      width: 100
    },
    {
      text: 'Match Score',
      align: 'center',
      value: 'match_weight',
      width: 50
    },
    {
      text: 'External code',
      align: 'center',
      value: 'orig_external_code',
      width: 50
    },
    {
      text: 'Details',
      align: 'center',
      value: 'actions'
    }
    // {
    //     text: "History",
    //     align: "center",
    //     value: "data-table-expand"
    // }
  ],
  NEEDS_RE_REVIEW: [
    {
      text: 'Status',
      align: 'center',
      sortable: false,
      value: 'status'
    },
    {
      text: 'Original category name',
      align: 'center',
      value: 'orig_cat1'
    },
    {
      text: 'Original code',
      align: 'center',
      value: 'orig_code'
    },
    {
      text: 'Original name',
      align: 'center',
      value: 'orig_name'
    },
    {
      text: 'Rhapsody name',
      align: 'center',
      value: 'rhapsody_name'
    },
    {
      text: 'Rhapsody code',
      align: 'center',
      value: 'rhapsody_code',
      width: 100
    },
    {
      text: 'Variation',
      align: 'center',
      value: 'variation'
    },
    {
      text: 'Category name',
      align: 'center',
      value: 'category'
    },
    {
      width: 100,
      text: 'Dispensing fee',
      align: 'center',
      value: 'dispensing_fee'
    },
    {
      width: 100,
      text: 'Price',
      align: 'center',
      value: 'priceInfo.price'
    },
    {
      width: 50,
      text: 'Minimum price',
      align: 'center',
      value: 'priceInfo.minimum_price',
      sortable: true,
      type: 'pricePart'
    },
    {
      width: 150,
      text: 'Revenue percent',
      align: 'center',
      value: 'revenue_percent',
      sortable: true
    },
    {
      text: 'Classification priority',
      align: 'center',
      value: 'bucket',
      sortable: true
    },
    {
      width: 80,
      text: 'GL Code',
      align: 'center',
      value: 'custom_gl_code',
      sortable: true
    },
    {
      width: 80,
      text: 'Last sold',
      align: 'center',
      value: 'priceInfo.lastsold',
      sortable: true,
      type: 'pricePart'
    },
    {
      width: 50,
      text: 'Total sold',
      align: 'center',
      value: 'priceInfo.total_sold',
      sortable: true,
      type: 'pricePart'
    },
    {
      width: 50,
      text: 'Last year',
      align: 'center',
      value: 'priceInfo.total_sold_12',
      sortable: true,
      type: 'pricePart'
    },
    {
      width: 50,
      text: '2 years ago',
      align: 'center',
      value: 'priceInfo.total_sold_24',
      sortable: true,
      type: 'pricePart'
    },
    {
      width: 50,
      text: '3 years ago',
      align: 'center',
      value: 'priceInfo.total_sold_36',
      sortable: false,
      type: 'pricePart'
    },
    {
      text: 'UPC',
      align: 'center',
      value: 'upc',
      sortable: true
    },
    {
      text: 'NDC',
      align: 'center',
      value: 'ndc',
      sortable: true
    },
    {
      text: 'Barcode',
      align: 'center',
      value: 'barcode',
      sortable: true
    },
    {
      text: 'Reviewed',
      align: 'center',
      value: 'reviewed',
      sortable: true
    },
    {
      text: 'Customer verified',
      align: 'center',
      value: 'migrationPoll.checked',
      sortable: false
    },
    {
      text: 'Analysis status',
      align: 'center',
      value: 'analyze_status',
      sortable: false
    },
    {
      text: 'Import status',
      align: 'center',
      value: 'import_status',
      sortable: false
    },
    {
      text: 'Last comment',
      align: 'center',
      value: 'lastComment',
      width: 200
    },
    {
      text: 'Customer notes',
      align: 'center',
      value: 'migrationPoll.notes',
      sortable: false,
      width: 100
    },
    {
      text: 'Match Score',
      align: 'center',
      value: 'match_weight',
      width: 50
    },
    {
      text: 'External code',
      align: 'center',
      value: 'orig_external_code',
      width: 50
    },
    {
      text: 'Details',
      align: 'center',
      value: 'actions'
    }
    // {
    //     text: "History",
    //     align: "center",
    //     value: "data-table-expand"
    // }
  ]
};

export const TABS = [
  {
    id: 0,
    title: 'All',
    headers: HEADERS.ALL
  },
  {
    id: 1,
    title: 'Procedures',
    headers: HEADERS.PROCEDURES,
    params: {
      categories: ['procedure']
    }
  },
  {
    id: 2,
    title: 'Labs',
    headers: HEADERS.LABS,
    params: {
      categories: ['lab']
    }
  },
  {
    id: 3,
    title: 'Drugs',
    headers: HEADERS.DRUGS,
    params: {
      categories: ['drug']
    }
  },
  {
    id: 15,
    title: 'Vaccines',
    headers: HEADERS.VACCINES,
    params: {
      categories: ['vaccine']
    }
  },
  {
    id: 4,
    title: 'Food',
    headers: HEADERS.FOOD,
    params: {
      categories: ['food']
    }
  },
  {
    id: 5,
    title: 'Supplies',
    headers: HEADERS.SUPPLIES,
    params: {
      categories: ['supply']
    }
  },
  {
    id: 6,
    title: 'Ignored',
    headers: HEADERS.IGNORED,
    params: {
      categories: ['ignore']
    }
  },
  {
    id: 7,
    title: 'Unmatched',
    headers: HEADERS.UNMATCHED,
    params: {
      categories: ['unmatched']
    }
  },
  {
    id: 9,
    title: 'Ask customer',
    headers: HEADERS.ASK_CUSTOMER,
    params: {
      statusesNames: ['ask_customer'],
      groupBy: ['category'],
      exclude: {
        multimatch: DEFAULTS.MULTIMATCH_FIELDS
      }
    }
  },
  {
    id: 11,
    title: 'Additional analysis',
    headers: HEADERS.ADDITIONAL_ANALYSIS,
    params: {
      lastSold: true
      // groupBy: [
      //     "priceInfo.total_sold",
      //     "priceInfo.total_sold_12",
      //     "priceInfo.total_sold_24",
      //     "priceInfo.total_sold_36"
      // ]
    }
  },
  {
    id: 12,
    title: 'Conflicts',
    headers: HEADERS.CONFLICTS,
    params: {
      conflicts: ['rhapsody_code']
    }
  },
  {
    id: 13,
    title: 'Needs change',
    headers: HEADERS.NEEDS_CHANGE,
    params: {
      statusesNames: ['needs_change', 'needs_code_change', 'supply']
    }
  },
  {
    id: 14,
    title: 'Needs re-review',
    headers: HEADERS.NEEDS_RE_REVIEW,
    params: {
      statusesNames: ['needs_re_review']
    }
  }
];
